import { I18n } from 'react-redux-i18n';

import { useSession } from '../../hooks';
import type { Session } from '../../modules/session';
import { StickyNotice, stickyNoticeTone } from '../common/stickyNoticeBar';

interface LayoutNoticeHandlers {
  onStopImpersonating: () => void;
}

const impersonationNotice = (
  account: Session['account'],
  onStopImpersonating: () => void
): StickyNotice => {
  const name = [account?.firstName, account?.lastName]
    .filter(Boolean)
    .join(' ');
  const email = account?.email ?? '';

  return {
    id: 'impersonation',
    tone: stickyNoticeTone.warning,
    message: name
      ? I18n.t('general.notice-bar.impersonating', { name, email })
      : I18n.t('general.notice-bar.impersonating-email', { email }),
    action: {
      label: I18n.t('account.remove-impersonate-action'),
      onClick: onStopImpersonating
    }
  };
};

/** Notices pinned above every admin page, in display order. */
export const useLayoutNotices = ({
  onStopImpersonating
}: LayoutNoticeHandlers): StickyNotice[] => {
  const session = useSession();
  const notices: StickyNotice[] = [];

  if (session.impersonated) {
    notices.push(impersonationNotice(session.account, onStopImpersonating));
  }

  return notices;
};
